import * as React from "react";

import { ProminentErrorMessageBox, SingleLineTextInput } from "../../Common";

import {
  useApplyAGiftcardForm,
  useDrawerGiftcardHelp_asController,
} from "../providers";

export const ApplyAGiftCard = ( { showForm }: {showForm: boolean} ) => {
  const {
    onFormFieldFocus,
    onFormInputChange,
    onFormInputBlur,
    applyAGiftcardForm,
    applyTheGiftcard,
  } = useApplyAGiftcardForm();

  const { handleOpen: drawerGiftcardHelp_handleOpen } =
    useDrawerGiftcardHelp_asController();

  const onFormSubmit: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        applyTheGiftcard();
      },
      [applyTheGiftcard]
    );

  const handleUserHavingTroubleHelp: React.MouseEventHandler<HTMLAnchorElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        drawerGiftcardHelp_handleOpen();
      },
      [drawerGiftcardHelp_handleOpen]
    );

  return (
    <React.Fragment>
      { showForm && (<React.Fragment>
        <form className="apply-a-giftcard">
          <SingleLineTextInput
            name="giftcardNumber"
            form={applyAGiftcardForm}
            onFocus={onFormFieldFocus}
            onChange={onFormInputChange}
            onBlur={onFormInputBlur}
            displayName="Gift Card Number"
            notice="The 19-digit number on your PDF or on the back of your card."
          />

          <SingleLineTextInput
            type="password"
            autoComplete="bbnt-giftcard-pin"
            name="giftcardPin"
            form={applyAGiftcardForm}
            onFocus={onFormFieldFocus}
            onChange={onFormInputChange}
            onBlur={onFormInputBlur}
            displayName="PIN"
            notice="The 4-digit security code on your PDF or on the back of your card."
          />

          <ProminentErrorMessageBox />

          <div className="apply-a-giftcard-actions">
            <button
              className="check-your-balance"
              onClick={onFormSubmit}
            >{`APPLY`}</button>
            <a
              href="javascript:void(0);"
              onClick={handleUserHavingTroubleHelp}
            >{`Having trouble applying your gift card?`}</a>
          </div>
        </form>
      </React.Fragment>)}
    </React.Fragment>
  );
};
